export const RegionSuggestionService = [
    "$resource",
    ($resource: any) => {
        return $resource("/user/regions");
    },
];
